import type { DaySeries } from "./day-bars.tsx";

// The Trends charts' series, shared by the Days and the Weeks and Months
// views. Kept apart from the chart files, which load ECharts.

export const WET = "var(--chart-wet)";
export const DIRTY = "var(--chart-dirty)";

/** Stacked bottom to top: wet, then both between its two colors, then dirty. */
export const CHANGES: DaySeries[] = [
  { key: "wet", label: "Wet only", colors: [WET] },
  { key: "both", label: "Wet and dirty", colors: [WET, DIRTY], variant: "mixed" },
  { key: "dirty", label: "Dirty only", colors: [DIRTY] },
];

/** A week's or a month's average amount a day. */
export const AVERAGE: DaySeries[] = [
  { key: "avg", label: "Average a day", colors: ["var(--accent)"] },
];

/** A night's average sleep: the longest stretch solid, the rest lighter, as on the Days chart. */
export const SLEEP: DaySeries[] = [
  { key: "longest", label: "Longest stretch", colors: ["var(--chart-sleep)"] },
  { key: "rest", label: "Other sleep", colors: ["var(--chart-sleep-light)"] },
];
